import React, { useState } from 'react';
import api from "../../utils/axiosInstance";
import { useSearchParams, useNavigate } from 'react-router-dom';
import HeaderBlue from '../../components/HeaderBlue';
import FooterBlue from '../../components/FooterBlue';

const ResetPassword = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const email = searchParams.get('email');
    const token = searchParams.get('token');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');

    const handleReset = async (e) => {
        e.preventDefault();
        try {
            const res = await api.post('/auth/reset-password', {
                email,
                token,
                password,
            });
            setMessage(res.data.message || "Password reset successful!");
            setTimeout(() => navigate('/driver-login'), 2000);
        } catch (error) {
            setMessage(error.response?.data?.message || "Failed to reset password.");
        }
    };

    return (
        <div className="bg-gray-100 min-h-screen flex flex-col font-oswald">
            <HeaderBlue />

            {/* Hero Section */}
            <section className="w-full py-60 relative"
                style={{
                    backgroundImage: "url('./assets/LOGIN.webp')",
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }}>
                <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-white/10 z-0"></div>
                <div className="md:px-40 relative z-10"></div>
            </section>

            {/* Reset Form */}
            <div className="flex items-center justify-center p-4 -mt-40 relative z-10 mb-10">
                <div className="w-full max-w-md p-8 rounded-lg shadow-xl border border-gray-300 bg-white/85 backdrop-blur-md">
                    <div className="text-center mb-8">
                        <h1 className="text-3xl font-bold text-primary mb-2">RESET PASSWORD</h1>
                        <p className="text-gray-600">Set your new password</p>
                    </div>

                    <form onSubmit={handleReset} className="space-y-6">
                        <div>
                            <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
                                New Password
                            </label>
                            <input
                                type="password"
                                id="password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-secondary focus:border-transparent"
                                placeholder="Enter new password"
                            />
                        </div>

                        <div>
                            <button
                                type="submit"
                                className="w-full bg-secondary text-white font-bold py-2 px-4 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary transition"
                            >
                                Update Password
                            </button>
                        </div>
                    </form>

                    {message && <p className="text-center mt-4 text-sm text-gray-700">{message}</p>}
                </div>
            </div>

            <FooterBlue />
        </div>
    );
};

export default ResetPassword;
